import { render, staticRenderFns } from "./EmployeeDocumentsTypesManager.vue?vue&type=template&id=1835c098"
import script from "./EmployeeDocumentsTypesManager.vue?vue&type=script&lang=js"
export * from "./EmployeeDocumentsTypesManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports